'use client';

import { useKeyboardStatus } from '@/hooks';
import { usePagination } from '@/hooks/usePagination';
import { ProgressBar } from '@prenuvo/halo-web';
import { isMobile } from 'react-device-detect';
import { NavigationButtons, NavigationDetails } from '.';

interface StickyNavigationProps {
  onNextPage: () => boolean | Promise<boolean>;
  onPreviousPage?: () => void;
}

// TODO: move to layout.js to avoid repetition and fix spacing
// TODO: add a handler to run validation and submission before navigating
export default function StickyNavigation({ onNextPage, onPreviousPage }: StickyNavigationProps) {
  const { currentIndex, totalSteps } = usePagination();
  const isKeyboardOpen = useKeyboardStatus(isMobile);

  return (
    <>
      <div className={`${isKeyboardOpen ? '' : 'sticky'} bottom-0 z-50 -m-4 bg-white`}>
        <div className="mb-3 sm:mb-6">
          <ProgressBar value={(currentIndex / (totalSteps - 1)) * 100} />
        </div>
        <div className="horizontal-padding flex flex-col justify-between px-4 pb-6 md:flex-row">
          <NavigationDetails />
          <NavigationButtons onNextPage={onNextPage} onPreviousPage={onPreviousPage} />
        </div>
      </div>
    </>
  );
}
